export default "__VITE_ASSET__BlpFTdfB__"